import { useEffect } from 'react';

import { useUpdateActivity } from '@/features/auth/api/use-update-activity';
import { useUserActivityStore } from '@/store/use-user-activity-store';

const SYNC_INTERVAL = 60 * 1000; // 1 minute

export function useUserActivity() {
  const { lastActivityTime, lastActivitySyncTime, setLastActivitySyncTime } = useUserActivityStore();
  const { mutate: updateActivity } = useUpdateActivity();

  useEffect(() => {
    const now = Date.now();

    if (lastActivityTime && (!lastActivitySyncTime || lastActivitySyncTime <= now - SYNC_INTERVAL)) {
      updateActivity(
        {
          timestamp: lastActivityTime,
        },
        {
          onSuccess: async () => {
            setLastActivitySyncTime(now);
          },
        },
      );
    }
  }, [lastActivityTime]);
}
